// extracted by mini-css-extract-plugin
module.exports =  {"container":"TwoColumns-module__container___E6vBe","sidemenu":"TwoColumns-module__sidemenu___czAme","main":"TwoColumns-module__main___vduYb"};